/**
 * Follow Next.js documentation for adding polyfills
 * https://nextjs.org/docs/app/api-reference/file-conventions/instrumentation-client#polyfills
 */
import './domain/polyfills'

import { installTranslationResilience } from 'translation-resilience'

import { apmRumInit } from './domain/apm'
import { cookiesGetOrGenerateRecommendationSessionId } from './domain/cookies'

apmRumInit()

installTranslationResilience()

/**
 * We need this cookie for GTM tracking
 * https://jira.shop-apotheke.com/browse/WSAWA-8052
 */
cookiesGetOrGenerateRecommendationSessionId()
